import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';

@Component({
    selector: 'app-referral-consent',
    templateUrl: './referral-consent.html',
    styleUrls: ['./referral-consent.component.css']
})
export class ReferralConsentComponent {
    public name: string;

    constructor(private router: Router, private activatedRoute: ActivatedRoute, public analyticsTracker: AnalyticsTracker) {
        if (this.activatedRoute.data) {
            this.activatedRoute.data.subscribe((data) => {
                this.name = data.name;
            });
        }
    }

    goNext() {
        this.router.navigate(['/invest/pan-verification']);
    }

    back() {
        this.router.navigate(['/lenderintro']);
    }

}
